import { useEducationInfoControllerGetInfoQuery } from '@api/admin/adminGeneratedApi';

export const useGetUniversities = () => {
  const { data, isLoading } = useEducationInfoControllerGetInfoQuery({ type: 'universities' });

  return { data, isLoading };
};
